import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import AddTask from './Task/AddTask'
import EditTask from './Task/EditTask'
import GlobalTaskOverview from './Task/GlobalTaskOverview'
import TaskOverview from './Task/TaskOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import { MenuItemKey } from '../components/MainMenu'

export const workflowBaseUrl = '/workflow'

export default function Workflows(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={workflowBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <>
                    <Route
                        exact
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            props.currentFile === undefined && props.currentCRMRelation === undefined ? (
                                <GlobalTaskOverview baseUrl={baseUrl} breadcrumb={MenuItemKey.Workflow} />
                            ) : (
                                <TaskOverview
                                    {...routeProps}
                                    {...props}
                                    fileId={props.currentFile?.id}
                                    crmRelationId={props.currentCRMRelation?.id}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTaskOverview-${props.currentFile?.id || props.currentCRMRelation?.id}-`}
                                />
                            )
                        }
                    />
                    <Route path={`${route}/add`}>
                        <AddTask returnUrl={baseUrl} currentFile={props.currentFile} />
                    </Route>
                    <Route path={`${route}/:id/edit`}>
                        <EditTask returnUrl={baseUrl} currentFile={props.currentFile} />
                    </Route>
                </>
            )}
        </EntityPage>
    )
}
